import { Radio, Typography } from "antd";

// PROG-WEEK-PARAMS/FE-5 — extracted from ExerciseProgressionEditor.tsx so the
// new WeekRow + SetRow sibling components can share these tiny presentational
// helpers without re-import cycles. Behaviour is unchanged.

export function FieldGroup({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <Typography.Text
        type="secondary"
        style={{ fontSize: 12, display: "block", marginBottom: 4 }}
      >
        {label}
      </Typography.Text>
      {children}
    </div>
  );
}

export function ModeToggle({
  value,
  onChange,
  options,
  disabled,
  testId,
}: {
  value: "select" | "free";
  onChange: (v: "select" | "free") => void;
  options: { label: string; value: "select" | "free" }[];
  disabled?: boolean;
  testId?: string;
}) {
  return (
    <Radio.Group
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      data-testid={testId}
      style={{ marginBottom: 4 }}
    >
      {options.map((o) => (
        <Radio.Button key={o.value} value={o.value}>
          {o.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
}
